module.exports = __webpack_public_path__ + "img/instagram.593b3f86.svg";